/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CdsOrientation } from '@cds/ng-core/configuration';
import { CdsRadioConfig } from '@cds/ng-core/radio';
import { CdsRadioModule } from '@cds/ng-web-components/radio';

export type CdRadioConfig = CdsRadioConfig & {
  options: {
    label: string;
    value: string | number | boolean;
    disable: boolean;
  }[];
};

@Component({
  selector: 'app-cd-radio',
  templateUrl: './cd-radio.component.html',
  styleUrls: ['./cd-radio.component.scss'],
  imports: [CdsRadioModule, FormsModule, ReactiveFormsModule],
})
export class CdRadioComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() value?: any;
  @Output() valueChange = new EventEmitter<any>();
  @Input() orientation: CdsOrientation = 'horizontal';
  @Input() config: CdRadioConfig = { options: [] } as CdRadioConfig;
  @Input() formControl?: FormControl;
  @ViewChild('cdRadio', { static: false }) cdRadio?: ElementRef<HTMLElement>;
  @Input() group!: FormGroup;
  @Input() controlName = '';

  disableList: boolean[] = [];
  private refreshTimer?: ReturnType<typeof setTimeout>;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.refreshConfig();
  }

  ngAfterViewInit(): void {
    this.refreshConfig();
  }

  ngOnDestroy(): void {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = undefined;
    }
  }

  refreshConfig() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }

    this.refreshTimer = setTimeout(() => {
      const options = Array.isArray(this.config?.options) ? this.config.options : [];
      this.disableList = options.map((item: { disable: boolean }) => item.disable);

      const tempList = this.cdRadio?.nativeElement.getElementsByTagName('mat-radio-button');
      if (tempList) {
        for (let i = 0; i < tempList.length; i++) {
          if (this.disableList[i]) {
            tempList.item(i)?.classList.add('disable');
          } else {
            tempList.item(i)?.classList.remove('disable');
          }
        }
      }
      this.refreshTimer = undefined;
    }, 0);
  }
}
